/** CoStar.Api.AptsLead.ViewModels.LeadType */
export var LeadType;
(function (LeadType) {
    LeadType[LeadType["None"] = 0] = "None";
    LeadType[LeadType["Email"] = 1] = "Email";
    LeadType[LeadType["Phone"] = 2] = "Phone";
    LeadType[LeadType["FinderSitesEmail"] = 3] = "FinderSitesEmail";
    LeadType[LeadType["FinderSitesPhone"] = 4] = "FinderSitesPhone";
    LeadType[LeadType["WebsiteLink"] = 5] = "WebsiteLink";
    LeadType[LeadType["Tour"] = 6] = "Tour";
    LeadType[LeadType["Application"] = 7] = "Application";
    LeadType[LeadType["RequestToApply"] = 8] = "RequestToApply";
    LeadType[LeadType["VirtualCall"] = 9] = "VirtualCall";
    LeadType[LeadType["ChatBot"] = 10] = "ChatBot";
    LeadType[LeadType["ChatBotTour"] = 11] = "ChatBotTour";
    LeadType[LeadType["AgentDirectory"] = 12] = "AgentDirectory";
    LeadType[LeadType["UnitApplication"] = 13] = "UnitApplication";
    LeadType[LeadType["TextLead"] = 14] = "TextLead";
})(LeadType || (LeadType = {}));
/** CoStar.Api.AptsLead.ViewModels.SortType */
export var SortType;
(function (SortType) {
    SortType[SortType["None"] = 0] = "None";
    SortType[SortType["PropertyName"] = 1] = "PropertyName";
    SortType[SortType["DateTime"] = 2] = "DateTime";
    SortType[SortType["Caller"] = 3] = "Caller";
    SortType[SortType["RingTo"] = 4] = "RingTo";
    SortType[SortType["Tracking"] = 5] = "Tracking";
    SortType[SortType["Duration"] = 6] = "Duration";
    SortType[SortType["Status"] = 7] = "Status";
    SortType[SortType["RenterName"] = 8] = "RenterName";
    SortType[SortType["RenterPhone"] = 9] = "RenterPhone";
    SortType[SortType["RenterEmail"] = 10] = "RenterEmail";
    SortType[SortType["MoveDate"] = 11] = "MoveDate";
    SortType[SortType["ContactVia"] = 12] = "ContactVia";
    SortType[SortType["MaxRent"] = 13] = "MaxRent";
    SortType[SortType["BedsBaths"] = 14] = "BedsBaths";
    SortType[SortType["ReasonForMoving"] = 15] = "ReasonForMoving";
    SortType[SortType["Address"] = 16] = "Address";
    SortType[SortType["RowStatus"] = 100] = "RowStatus";
    SortType[SortType["LeadType"] = 110] = "LeadType";
    SortType[SortType["VendorTask"] = 120] = "VendorTask";
})(SortType || (SortType = {}));
import { SortOrder } from "../../../../CoStar/Api/AptsAnalytics/ViewModels/index.js";
/** CoStar.Api.AptsLead.ViewModels.SortOrder */
export { SortOrder };
/** CoStar.Api.AptsLead.ViewModels.LeadExternalRefType */
export var LeadExternalRefType;
(function (LeadExternalRefType) {
    LeadExternalRefType[LeadExternalRefType["None"] = 0] = "None";
    LeadExternalRefType[LeadExternalRefType["Tour"] = 1] = "Tour";
    LeadExternalRefType[LeadExternalRefType["Application"] = 2] = "Application";
    LeadExternalRefType[LeadExternalRefType["RequestToApply"] = 3] = "RequestToApply";
    LeadExternalRefType[LeadExternalRefType["RequestToApplyIntegrated"] = 4] = "RequestToApplyIntegrated";
    LeadExternalRefType[LeadExternalRefType["VirtualCall"] = 5] = "VirtualCall";
    LeadExternalRefType[LeadExternalRefType["TourEmail"] = 6] = "TourEmail";
    LeadExternalRefType[LeadExternalRefType["RequestToApplyFeedClaim"] = 7] = "RequestToApplyFeedClaim";
    LeadExternalRefType[LeadExternalRefType["ChatBot"] = 10] = "ChatBot";
    LeadExternalRefType[LeadExternalRefType["ChatBotTour"] = 11] = "ChatBotTour";
    LeadExternalRefType[LeadExternalRefType["AgentDirectory"] = 12] = "AgentDirectory";
    LeadExternalRefType[LeadExternalRefType["UnitApplication"] = 13] = "UnitApplication";
    LeadExternalRefType[LeadExternalRefType["HomesUtmSource"] = 16] = "HomesUtmSource";
    LeadExternalRefType[LeadExternalRefType["HomesUtmMedium"] = 17] = "HomesUtmMedium";
    LeadExternalRefType[LeadExternalRefType["HomesUtmCampaign"] = 18] = "HomesUtmCampaign";
    LeadExternalRefType[LeadExternalRefType["HomesUtmTerm"] = 19] = "HomesUtmTerm";
    LeadExternalRefType[LeadExternalRefType["HomesUtmContent"] = 20] = "HomesUtmContent";
    LeadExternalRefType[LeadExternalRefType["HomesLeadGUID"] = 21] = "HomesLeadGUID";
    LeadExternalRefType[LeadExternalRefType["Entrata"] = 500] = "Entrata";
    LeadExternalRefType[LeadExternalRefType["YardiGuestcard"] = 501] = "YardiGuestcard";
    LeadExternalRefType[LeadExternalRefType["Lead2Lease"] = 502] = "Lead2Lease";
    LeadExternalRefType[LeadExternalRefType["AnyoneHome"] = 503] = "AnyoneHome";
    LeadExternalRefType[LeadExternalRefType["HolidayRetirement"] = 504] = "HolidayRetirement";
    LeadExternalRefType[LeadExternalRefType["Keyes"] = 505] = "Keyes";
    LeadExternalRefType[LeadExternalRefType["HubSpot"] = 506] = "HubSpot";
    LeadExternalRefType[LeadExternalRefType["YardiPopCard"] = 507] = "YardiPopCard";
    LeadExternalRefType[LeadExternalRefType["IrvineCompany"] = 508] = "IrvineCompany";
    LeadExternalRefType[LeadExternalRefType["ProgressResidential"] = 509] = "ProgressResidential";
    LeadExternalRefType[LeadExternalRefType["YardiCrm"] = 510] = "YardiCrm";
    LeadExternalRefType[LeadExternalRefType["Dwell"] = 511] = "Dwell";
    LeadExternalRefType[LeadExternalRefType["Knock"] = 512] = "Knock";
    LeadExternalRefType[LeadExternalRefType["CommonLiving"] = 513] = "CommonLiving";
    LeadExternalRefType[LeadExternalRefType["Elegran"] = 514] = "Elegran";
    LeadExternalRefType[LeadExternalRefType["Zoho"] = 515] = "Zoho";
    LeadExternalRefType[LeadExternalRefType["Lasso"] = 516] = "Lasso";
    LeadExternalRefType[LeadExternalRefType["ResMan"] = 517] = "ResMan";
    LeadExternalRefType[LeadExternalRefType["ResManMITS"] = 518] = "ResManMITS";
    LeadExternalRefType[LeadExternalRefType["Fortress"] = 520] = "Fortress";
    LeadExternalRefType[LeadExternalRefType["TextLead"] = 521] = "TextLead";
    LeadExternalRefType[LeadExternalRefType["DynamicLeadConfiguration"] = 9999] = "DynamicLeadConfiguration";
})(LeadExternalRefType || (LeadExternalRefType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkLeadType */
export var MktNwkLeadType;
(function (MktNwkLeadType) {
    MktNwkLeadType[MktNwkLeadType["Email"] = 1] = "Email";
    MktNwkLeadType[MktNwkLeadType["Phone"] = 2] = "Phone";
    MktNwkLeadType[MktNwkLeadType["Text"] = 14] = "Text";
})(MktNwkLeadType || (MktNwkLeadType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkLeadStatusType */
export var MktNwkLeadStatusType;
(function (MktNwkLeadStatusType) {
    MktNwkLeadStatusType[MktNwkLeadStatusType["New"] = 1] = "New";
    MktNwkLeadStatusType[MktNwkLeadStatusType["AttemptedContact"] = 2] = "AttemptedContact";
    MktNwkLeadStatusType[MktNwkLeadStatusType["InContact"] = 3] = "InContact";
    MktNwkLeadStatusType[MktNwkLeadStatusType["AppointmentSet"] = 4] = "AppointmentSet";
    MktNwkLeadStatusType[MktNwkLeadStatusType["Nurture"] = 5] = "Nurture";
    MktNwkLeadStatusType[MktNwkLeadStatusType["Closed"] = 6] = "Closed";
    MktNwkLeadStatusType[MktNwkLeadStatusType["Archive"] = 7] = "Archive";
    MktNwkLeadStatusType[MktNwkLeadStatusType["Spam"] = 8] = "Spam";
})(MktNwkLeadStatusType || (MktNwkLeadStatusType = {}));
/** CoStar.Api.AptsLead.ViewModels.LeadRecipientType */
export var LeadRecipientType;
(function (LeadRecipientType) {
    LeadRecipientType[LeadRecipientType["Agent"] = 1] = "Agent";
    LeadRecipientType[LeadRecipientType["Office"] = 2] = "Office";
    LeadRecipientType[LeadRecipientType["User"] = 3] = "User";
})(LeadRecipientType || (LeadRecipientType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkLeadRole */
export var MktNwkLeadRole;
(function (MktNwkLeadRole) {
    MktNwkLeadRole[MktNwkLeadRole["Consumer"] = 1] = "Consumer";
    MktNwkLeadRole[MktNwkLeadRole["Agent"] = 15] = "Agent";
})(MktNwkLeadRole || (MktNwkLeadRole = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkLeadSearchType */
export var MktNwkLeadSearchType;
(function (MktNwkLeadSearchType) {
    MktNwkLeadSearchType[MktNwkLeadSearchType["Unknown"] = 0] = "Unknown";
    MktNwkLeadSearchType[MktNwkLeadSearchType["Name"] = 1] = "Name";
    MktNwkLeadSearchType[MktNwkLeadSearchType["Email"] = 2] = "Email";
    MktNwkLeadSearchType[MktNwkLeadSearchType["Phone"] = 3] = "Phone";
})(MktNwkLeadSearchType || (MktNwkLeadSearchType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkLeadSortType */
export var MktNwkLeadSortType;
(function (MktNwkLeadSortType) {
    MktNwkLeadSortType[MktNwkLeadSortType["None"] = 0] = "None";
    MktNwkLeadSortType[MktNwkLeadSortType["DateTime"] = 1] = "DateTime";
    MktNwkLeadSortType[MktNwkLeadSortType["Name"] = 2] = "Name";
    MktNwkLeadSortType[MktNwkLeadSortType["Type"] = 3] = "Type";
    MktNwkLeadSortType[MktNwkLeadSortType["Source"] = 4] = "Source";
    MktNwkLeadSortType[MktNwkLeadSortType["Phone"] = 5] = "Phone";
    MktNwkLeadSortType[MktNwkLeadSortType["Status"] = 6] = "Status";
})(MktNwkLeadSortType || (MktNwkLeadSortType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkLeadTypeaheadSearchType */
export var MktNwkLeadTypeaheadSearchType;
(function (MktNwkLeadTypeaheadSearchType) {
    MktNwkLeadTypeaheadSearchType[MktNwkLeadTypeaheadSearchType["Name"] = 1] = "Name";
    MktNwkLeadTypeaheadSearchType[MktNwkLeadTypeaheadSearchType["Email"] = 2] = "Email";
    MktNwkLeadTypeaheadSearchType[MktNwkLeadTypeaheadSearchType["Phone"] = 3] = "Phone";
    MktNwkLeadTypeaheadSearchType[MktNwkLeadTypeaheadSearchType["City"] = 4] = "City";
})(MktNwkLeadTypeaheadSearchType || (MktNwkLeadTypeaheadSearchType = {}));
/** CoStar.Api.AptsLead.ViewModels.Language */
export var Language;
(function (Language) {
    Language[Language["Unknown"] = 0] = "Unknown";
    Language[Language["English"] = 1] = "English";
    Language[Language["Spanish"] = 2] = "Spanish";
})(Language || (Language = {}));
/** CoStar.Api.AptsLead.ViewModels.SiteName */
export var SiteName;
(function (SiteName) {
    SiteName[SiteName["Unknown"] = 0] = "Unknown";
    SiteName[SiteName["Apartments"] = 1] = "Apartments";
    SiteName[SiteName["RentalHomesPlus"] = 2] = "RentalHomesPlus";
    SiteName[SiteName["MobileApartments"] = 3] = "MobileApartments";
    SiteName[SiteName["ApartmentsHomeLiving"] = 5] = "ApartmentsHomeLiving";
    SiteName[SiteName["Move"] = 14] = "Move";
    SiteName[SiteName["WestsideRentals"] = 15] = "WestsideRentals";
    SiteName[SiteName["Homes"] = 16] = "Homes";
    SiteName[SiteName["AndroidApartments"] = 100] = "AndroidApartments";
    SiteName[SiteName["IPhoneApartments"] = 101] = "IPhoneApartments";
    SiteName[SiteName["IPhoneRHP"] = 102] = "IPhoneRHP";
    SiteName[SiteName["AndroidRHP"] = 103] = "AndroidRHP";
    SiteName[SiteName["AppsTollFree"] = 104] = "AppsTollFree";
    SiteName[SiteName["ApartmentFinder"] = 500] = "ApartmentFinder";
    SiteName[SiteName["MobileApartmentFinder"] = 501] = "MobileApartmentFinder";
    SiteName[SiteName["IPhoneApartmentFinder"] = 502] = "IPhoneApartmentFinder";
    SiteName[SiteName["AndroidApartmentFinder"] = 503] = "AndroidApartmentFinder";
    SiteName[SiteName["FinderSite"] = 504] = "FinderSite";
    SiteName[SiteName["MobileFinderSite"] = 505] = "MobileFinderSite";
    SiteName[SiteName["IPhoneFinderSite"] = 506] = "IPhoneFinderSite";
    SiteName[SiteName["AndroidFinderSite"] = 507] = "AndroidFinderSite";
    SiteName[SiteName["ForRent"] = 508] = "ForRent";
    SiteName[SiteName["ForRentMobile"] = 509] = "ForRentMobile";
    SiteName[SiteName["ForRentUniversity"] = 510] = "ForRentUniversity";
    SiteName[SiteName["ForRentUniversityMobile"] = 511] = "ForRentUniversityMobile";
    SiteName[SiteName["After55"] = 512] = "After55";
    SiteName[SiteName["CorporateHousing"] = 513] = "CorporateHousing";
    SiteName[SiteName["ForRentIPhone"] = 514] = "ForRentIPhone";
    SiteName[SiteName["ForRentAndroid"] = 515] = "ForRentAndroid";
    SiteName[SiteName["OffCampusPartners"] = 516] = "OffCampusPartners";
    SiteName[SiteName["OffCampusPartnersMobile"] = 517] = "OffCampusPartnersMobile";
    SiteName[SiteName["OffCampusPartnersIPhone"] = 518] = "OffCampusPartnersIPhone";
    SiteName[SiteName["OffCampusPartnersAndroid"] = 519] = "OffCampusPartnersAndroid";
})(SiteName || (SiteName = {}));
/** CoStar.Api.AptsLead.ViewModels.CallDisposition */
export var CallDisposition;
(function (CallDisposition) {
    CallDisposition[CallDisposition["Unknown"] = 0] = "Unknown";
    CallDisposition[CallDisposition["Completed"] = 1] = "Completed";
    CallDisposition[CallDisposition["Missed"] = 2] = "Missed";
    CallDisposition[CallDisposition["Busy"] = 3] = "Busy";
    CallDisposition[CallDisposition["RangNoAnswer"] = 4] = "RangNoAnswer";
    CallDisposition[CallDisposition["Abandoned"] = 5] = "Abandoned";
})(CallDisposition || (CallDisposition = {}));
/** CoStar.Api.AptsLead.ViewModels.ContactPreference */
export var ContactPreference;
(function (ContactPreference) {
    ContactPreference[ContactPreference["None"] = 0] = "None";
    ContactPreference[ContactPreference["Email"] = 1] = "Email";
    ContactPreference[ContactPreference["Phone"] = 2] = "Phone";
})(ContactPreference || (ContactPreference = {}));
/** CoStar.Api.AptsLead.ViewModels.MoveReason */
export var MoveReason;
(function (MoveReason) {
    MoveReason[MoveReason["None"] = 0] = "None";
    MoveReason[MoveReason["MoreLessSpace"] = 1] = "MoreLessSpace";
    MoveReason[MoveReason["JobChange"] = 2] = "JobChange";
    MoveReason[MoveReason["FamilyEvent"] = 3] = "FamilyEvent";
    MoveReason[MoveReason["Relocation"] = 4] = "Relocation";
    MoveReason[MoveReason["Other"] = 5] = "Other";
    MoveReason[MoveReason["Financial"] = 6] = "Financial";
    MoveReason[MoveReason["Personal"] = 7] = "Personal";
    MoveReason[MoveReason["WorkRelated"] = 8] = "WorkRelated";
    MoveReason[MoveReason["GottaGo"] = 9] = "GottaGo";
})(MoveReason || (MoveReason = {}));
/** CoStar.Api.AptsLead.ViewModels.DenyListType */
export var DenyListType;
(function (DenyListType) {
    DenyListType[DenyListType["None"] = 0] = "None";
    DenyListType[DenyListType["Email"] = 1] = "Email";
    DenyListType[DenyListType["Phone"] = 2] = "Phone";
})(DenyListType || (DenyListType = {}));
/** CoStar.Api.AptsLead.ViewModels.UserEntityType */
export var UserEntityType;
(function (UserEntityType) {
    UserEntityType[UserEntityType["None"] = 0] = "None";
    UserEntityType[UserEntityType["CostarContact"] = 1] = "CostarContact";
    UserEntityType[UserEntityType["HomesUser"] = 2] = "HomesUser";
    UserEntityType[UserEntityType["SIFTService"] = 3] = "SIFTService";
    UserEntityType[UserEntityType["HomesNetworkAdmin"] = 4] = "HomesNetworkAdmin";
})(UserEntityType || (UserEntityType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkSpamLeadSortType */
export var MktNwkSpamLeadSortType;
(function (MktNwkSpamLeadSortType) {
    MktNwkSpamLeadSortType[MktNwkSpamLeadSortType["None"] = 0] = "None";
    MktNwkSpamLeadSortType[MktNwkSpamLeadSortType["DateTime"] = 1] = "DateTime";
})(MktNwkSpamLeadSortType || (MktNwkSpamLeadSortType = {}));
/** CoStar.Api.AptsLead.ViewModels.MktNwkSpamLeadSourceType */
export var MktNwkSpamLeadSourceType;
(function (MktNwkSpamLeadSourceType) {
    MktNwkSpamLeadSourceType[MktNwkSpamLeadSourceType["None"] = 0] = "None";
    MktNwkSpamLeadSourceType[MktNwkSpamLeadSourceType["System"] = 1] = "System";
    MktNwkSpamLeadSourceType[MktNwkSpamLeadSourceType["Agent"] = 2] = "Agent";
})(MktNwkSpamLeadSourceType || (MktNwkSpamLeadSourceType = {}));
